import { useAddMealToMealPlanByDate } from './addMealToMealPlanByDate';
import { useAuth } from '../context/AuthContext';

export const useAddRecipeToMealPlan = () => {
  const { pgUser } = useAuth();
  const { addMealToMealPlanByDate, isLoading, error } = useAddMealToMealPlanByDate();

  const addRecipeToMealPlan = async ({ recipeId, servings, plannedCookDate }) => {
    try {
      if (!pgUser) {
        console.error('User not authenticated');
        return false;
      }

      const mealData = {
        recipe_id: recipeId,
        app_user_id: pgUser.id,
        serving_size: servings,
        meal_of_day: 'dinner',
        planned_cook_date: plannedCookDate,
        actual_cook_date: null,
        has_been_cooked: false,
        is_favorite: false
      };

      const result = await addMealToMealPlanByDate(mealData);
      
      if (result) {
        return true;
      } else {
        console.error('Failed to add meal to plan');
        return false;
      }
    } catch (error) {
      console.error('Error adding recipe to meal plan:', error);
      return false;
    }
  };

  return {
    addRecipeToMealPlan,
    isLoading,
    error
  };
};

